export default __webpack_public_path__ + "static/media/jee_test_prep_icon.69605ab4.svg";